export class SimpleModel {
  public id!: string;

  public name!: string;

  constructor(init?: Partial<SimpleModel>) {
    Object.assign(this, init);
  }
}
